import { Component, OnInit, ViewChild } from "@angular/core";
import { UntypedFormGroup, Validators } from "@angular/forms";
import { NbWindowRef } from "@nebular/theme";
import {
  RxFormBuilder,
  RxwebValidators,
} from "@rxweb/reactive-form-validators";
import { Subscription } from "rxjs";
import { MxCell, MxGraph } from "../../../../@core/model/mxgraph";
import { Transcribe } from "../../../../@core/model/transcribe";
import { GraphHandlerService } from "../../../../@core/utils/graph.service";
import {
  noWhitespaceValidator,
  ValidInput,
} from "../../../../@core/utils/helpers";
import { DataService } from "./../../../../@core/utils/data.service";

@Component({
  selector: "transcribe",
  templateUrl: "./transcribe.component.html",
  styleUrls: ["./transcribe.component.scss"],
})
export class TranscribeComponent implements OnInit {
  cell: MxCell;
  graph: MxGraph;
  data: Transcribe = new Transcribe();
  formGroup: UntypedFormGroup;
  selectedSubscription: Subscription;
  isLoading = false;
  cancelAction = false;
  errorMessage: string = "Variable is required.";
  listLanguage = [];
  callSetting: any;

  listlanguage = [];
  attributes: any = this.dataService.ivrAttribute;
  mentionConfig = {
    items: this.attributes,
    triggerChar: "{",
    labelKey: "value",
    disableSort: true,
    mentionSelect: (item) => {
      return "{" + item.value + "}";
    },
  };
  listVariablesCreated: any = [];
  tempLanguageVariable: string = "";
  speakerForm: UntypedFormGroup;

  jsonExample = `{
  "conversations": [
    {
      "speakerName": "John",
      "text": "How do you feel today?",
      "startTime": 0,
      "endTime": 1200,
      "duration": 1200
    },
    {
      "speakerName": "David", 
      "text": "I'm feeling great!",
      "startTime": 1500,
      "endTime": 3000,
      "duration": 1500
    }
  ]
}`;

  constructor(
    private windowRef: NbWindowRef,
    private formBuilder: RxFormBuilder,
    private graphService: GraphHandlerService,
    public dataService: DataService
  ) {
    this.createForm();
    this.createSpeakerForm();
  }

  ngOnInit(): void {
    for (const key in this.data) {
      const value = this.cell.getAttribute(key);
      if (key === "speakerList") {
        try {
          this.data.speakerList = JSON.parse(value);
          if (this.data.speakerList.length == 2) {
            this.speakerForm.patchValue({
              speaker1: this.data.speakerList[0],
              speaker2: this.data.speakerList[1],
            });
          } else {
            this.setDefaultSpeaker();
          }
        } catch (error) {
          this.setDefaultSpeaker();
        }
      } else {
        this.data[key] = value;
      }
    }

    //language
    if (!(this?.callSetting?.languageSetting == undefined)) {
      this.listlanguage =
        JSON.parse(this?.callSetting?.languageSetting) == null
          ? []
          : JSON.parse(this?.callSetting?.languageSetting);
    }
    if (this.listlanguage != undefined && this.listlanguage.length > 0) {
      this.listlanguage = this.listlanguage.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    }
    if (this.data.isConversation) {
      this.data.isConversation = this.data.isConversation.toString() === "true";
    } else {
      this.data.isConversation = false;
    }

    this.windowRef.onClose.subscribe(() => this.submit());
  }
  setDefaultSpeaker() {
    this.speakerForm.patchValue({
      speaker1: "Speaker 1",
      speaker2: "Speaker 2",
    });
  }
  ngOnDestroy() {
    if (this.selectedSubscription) {
      this.selectedSubscription.unsubscribe();
    }
  }

  createForm() {
    this.formGroup = this.formBuilder.group({
      input: ["", [RxwebValidators.required(), noWhitespaceValidator]],
    });
  }

  createSpeakerForm() {
    this.speakerForm = this.formBuilder.group({
      speaker1: [
        "",
        [Validators.maxLength(20), Validators.required, noWhitespaceValidator],
      ],
      speaker2: [
        "",
        [Validators.maxLength(20), Validators.required, noWhitespaceValidator],
      ],
    });
  }

  handleSaveAction() {
    this.windowRef.close();
  }

  handleCancelAction() {
    this.cancelAction = true;
    this.windowRef.close(true);
  }

  getOutputVariable($event) {
    this.data.transcriptionVariable = $event;
  }

  getLangVariable(event) {
    this.data.languageAttribute = event;
  }

  submit() {
    if (!this.cancelAction && !this.isLoading) {
      this.updateSpeakerList();
      for (let [key, value] of Object.entries(this.data)) {
        if (typeof this.data[key] == "string") {
          value = value?.trim();
        }
        this.cell.setAttribute(key, value || "");
      }
      const transcribeCell = this.graph.getModel().getCell(this.cell.getId());
      var fieldsRequired = [this.data.input, this.data.transcriptionVariable];
      if (this.data.languageOption == "variable") {
        fieldsRequired = [...fieldsRequired, this.data.languageAttribute];
      }
      const check = this.graphService.checkIsRequired(
        this.graph,
        fieldsRequired,
        transcribeCell
      );
      this.cell.setAttribute("checkFields", check?.toString());
    }
  }

  updateSpeakerList() {
    if (this.speakerForm.valid) {
      const speakers = [
        this.speakerForm.get("speaker1").value?.trim(),
        this.speakerForm.get("speaker2").value?.trim(),
      ];
      this.data.speakerList = JSON.stringify(speakers);
    }
  }

  onFormatChange(format: string) {
    this.data.format = format;
  }

  onConversationModeChange(checked: boolean) {
    this.data.isConversation = checked;
  }
}
